import { createSelector } from '@ngrx/store';
import type { ApplicationState } from '../../../reducers';

export interface UserState {
    userId: string,
    email: string,
    country: string,
    isGDPR: boolean,
    googleAnalyticClientId: string,
    cookieConsent: boolean
}

export const initialUserState: UserState = {
    userId: null,
    email: null,
    country: null,
    isGDPR: true,
    googleAnalyticClientId: null,
    cookieConsent: false,
};

export const getUserState = (state: ApplicationState) => state.user;

export const getUserIdSelector = createSelector(getUserState, (userState: UserState) => userState.userId);

export const getUserCountrySelector = createSelector(getUserState, (userState: UserState) => userState.country);

export const getUserEmailSelector = createSelector(getUserState, (userState: UserState) => userState.email);

export const getGoogleAnalyticClientId = createSelector(getUserState, (userState: UserState) => userState.googleAnalyticClientId);

export const getCookieConsent = createSelector(getUserState, (userState: UserState) => userState.cookieConsent);
